const initialState = {
    allData: [],
    currentImportConnector: [],
    importConnectorById: {},
    tableLoading: false,
    sidebarLoading: false,
    modalLoading: false,
    updatedConnector: {},
    searchImportConnector: [],
    searchOptions: {},
    importDeleteData: {
        emableModel: false,
        message: "",
        enableCancleButton: true,
        enableOkButton: true,
        headerMsg: "",
    },
    totalItems: 0,
    totalPages: 0,
    currentPage: 0,
    availableImportConnectors: [],
}

const ImportConnectorReducer = (state = initialState, action) => {
    const { type, payload, data, id, value } = action;

    switch (type) {
        case "SET_IMPORT_CONNECTOR":
            return {
                ...state,
                allData: data,
            }
        case "ADD_IMPORT_CONNECTOR":
            return {
                ...state,
                currentImportConnector: data
            }
        case "SET_IMPORT_CONNECTOR_BY_ID":
            return {
                ...state,
                importConnectorById: data
            }
        case "UPDATE_IMPORT_CONNECTOR":
            return {
                ...state,
                updatedConnector: data
            }
        case "SET_TABLE_LOADING":
            return {
                ...state,
                tableLoading: payload
            }
        case "SET_SIDEBAR_LOADING":
            return {
                ...state,
                sidebarLoading: payload
            }
        case "OPEN_IMPORT_DELETE":
            return {
                ...state,
                importDeleteData: value
            };
        case "SEARCH_IMPORT_CONNECTOR":
            return {
                ...state,
                searchImportConnector: data?.content,
                totalItems: data?.totalItems,
                totalPages: data?.totalPages,
                currentPage: data?.page,
            }
        case "SET_SEARCH_OPTIONS":
            return {
                ...state,
                searchOptions: data
            }
        case "SET_AVAILABLE_IMPORT_CONNECTORS":
            return {
                ...state,
                availableImportConnectors: data
            }   
        default:
            return state;
    }
}

export default ImportConnectorReducer;